
/**
 * JavaScript React Framework
 */
import React from 'react';
// import ReactDom from 'react-dom';

/**
 * React-Bootstrap
 */ 
import { Jumbotron, Thumbnail, Panel, Grid, Row, Col } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import MarketingBlock from '../../common/content/MarketingBlock.js';

import imgHeader_01 from '../../../assets/img/itbuildout/Duvall_Mine.jpg';
import imgHeader_02 from '../../../assets/img/itbuildout/Asarco_Mine.jpg';

let fontSize = {fontSize: '1.10em'};

/**
 * Note: Your components tell React what you want to render
 */
class ITBuildOut extends React.Component {
	render() {
		return (
			<div id="ITBuildOut">
				<Jumbotron>
	          <div>
	          	<Grid>
				    		<Row>
				    			<Col xs={12} md={12}>
				    				<center>
					    				<MarketingBlock header="IT Dot.Com Build-Out">
					    					Chief engineer and executive manager for planning and deploying a comprehensive heterogeneous Windows &amp; Solaris UNIX IT infrastructure with Cisco equipment throughout the networking stack over a Class-3 public subnet with a secondary fractional corporate public subnet. Some of the more salient aspects of this work include <a href="https://en.wikipedia.org/wiki/Sendmail">sendmail</a> inbound/outbound public mail with internal Microsoft Exchange servers; public UNIX <a href="https://www.isc.org/downloads/bind/">bind</a> DNS coupled to private Microsoft DNS with DHCP hosted by Windows; network experience include two ASA Cisco security appliances, <a href="https://en.wikipedia.org/wiki/RADIUS">radius</a> authentication, layer-3 switches, gigabit Ethernet, fiber switches, and IP telephony. 
					    					<hr/>
					    					During my three-year executive tour as Vice President of Software Development, my vision was to capitalize on automation to reduce cost and build a subscription model of revenue using an in-house web-driven learning management system coupled to a site deployed assessment and local content repository. Learning management content synchronized globally on a daily basis with the option for immediate deployment as needed by customer demand.
					    				</MarketingBlock>
				    				</center>
				    			</Col>
				    		</Row>

				    		<Row>
				    			<Col xs={12} md={6}>
				    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_01}>
				    				<h3>Executive Management</h3>
						          <p className="text-justify" style={fontSize}>Performance Associates International - <a href="http://www.perfnet.com">website</a>: six years of management with a three year executive management tour including international travel building strong customer relationships negotiating software product requirements with Rio Tinto leadership. My executive tour included managing two functional teams: Software Development and Computer-Based Training  with responsibilities spanning all information technology, software development, and computer-based training content generation. My leadership style emphasizes engineering task/activity based assignments.</p>
				    				</Thumbnail>
				    			</Col>

				    			<Col xs={12} md={6}>
				    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_02}>
				    				<h3>Engineering and Automation</h3>
						          <p className="text-justify" style={fontSize}>One of my main contributions in leadership was to incorporate paradigm shifting automation for the creation of our company computer-based training (CBT) materials. Automations were designed to limit human error and seamlessly transition engineer documentation into functional html. The original thrust for automation began as a project to aid budget conditions during Rio Tinto engineering by allowing more of our CBT budget to shift toward engineering. HTML QA was automated by a format and link checker invented and deployed within my learning management system.</p>
				    				</Thumbnail>
				    			</Col>
				    		</Row>
				    	</Grid>
	          </div>
				</Jumbotron>

				<Grid className="blockpadding">
	    		<div className="well">
	    			<Row>
		    			<Col xs={12} md={12}>
		    				<MarketingBlock header="Learning Management System (LMS)">
		    					<span style={fontSize}>The highlight of my career at Performance Associates centered on designing a comprehensive web-based <a href="https://en.wikipedia.org/wiki/Sharable_Content_Object_Reference_Model">SCORM</a> compliant learning management system (LMS) for training mine and metallurgical operators around the world. The LMS included a performance-focused multi-threaded web-server that interfaced the learning management system as an application server using URL paths as command strings. The back-end was built in C incorporating Solaris <a href="https://docs.oracle.com/cd/E18752_01/html/816-4854/task_queues.html">Task Queues</a> and 100% compliant <a href="https://en.wikipedia.org/wiki/POSIX_Threads">Posix threads</a>. The front-end was initially built using the Yahoo JavaScript web toolkit (<a href="https://yuilibrary.com/">YUI</a>) and later migrated to a Flash/<a href="http://www.adobe.com/products/flex.html">Flex</a> user interface using XML to communicate with the server.</span>
		    				</MarketingBlock>
		    			</Col>
		    		</Row>

		    		<Row>
		    			<Col xs={12} md={12}>
		    				<Panel>
		    					<center>
			    					<p style={fontSize}>In terms of systems administration, you could say that I fall into the camp of being a <a href="https://en.wikipedia.org/wiki/Vi">vi</a> guy; that said, I have always liked <a href="https://www.gnu.org/software/emacs/">emacs</a> but after developing <a href="https://www.learningtree.com/">training materials</a> for teaching advanced UNIX shell scripting using the Korn Shell, I became a vi guy.</p>
			    				</center>
			    			</Panel>
		    			</Col>
		    		</Row>

		    		<Row>
		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Systems Administration">
		    					I began my UNIX systems skillset on AIX while at <a href="http://www.ibm.com">IBM</a>, Systems Storage Division - Technology Group, working on a wide range of Power (S-70/80) and storage products including SHARK, <a href="https://en.wikipedia.org/wiki/Serial_Storage_Architecture">SSA</a>, <a href="https://en.wikipedia.org/wiki/RAID">RAID</a>, <a href="https://en.wikipedia.org/wiki/Non-RAID_drive_architectures#JBOD">JBOD</a>, and Linear Tape (<a href="https://www-03.ibm.com/ibm/history/exhibits/storage/storage_3570.html">Coyote</a>, <a href="https://en.wikipedia.org/wiki/IBM_3590">Blythe</a>). At Performance Associates I had extended this skillset to <a href="https://en.wikipedia.org/wiki/Solaris_(operating_system)">Solaris</a> and <a href="https://www.cisco.com/">Cisco</a> (routing and switching). The infrastructure was based on Solaris containers and virtualized environments with clustering across multiple servers.
		    				</MarketingBlock>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="ImageMagick">
		    					In light of automation, I had written several scripts using <a href="http://www.imagemagick.org/script/index.php">ImageMagick</a> to automatically build PNG layered graphics from flat file lists of alarm labels to help our graphics department remain more engaged in the more fulfilling work of process plant flow diagrams and custom 3D image design. These <a href="https://en.wikipedia.org/wiki/Portable_Network_Graphics">PNG</a> layered alarm label files were opened in their design software where each label could be dragged onto a canvas for labeling interlocks and alarms. 
		    				</MarketingBlock>
		    			</Col>
		    		</Row>

						<Row>
		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Class-3 Public Network">
		    					The hosting line of business I designed utilized virtualized containers on Solaris connected to a public Class-3 IP delegated from the telecommunication company. My vision included localized software with server-side content management with global synchronization on a moments notice. This allowed Performance Associates International to capitalize on subscription revenue.
		    				</MarketingBlock>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Storage">
		    					I had employed a large scale multi-terabyte storage system with a combination of RAID-5 over several trays - I designed this as a very high RPM subsystem for performance that was capable of losing an entire tray of drives without loss of data. We employed a tape robot subsystem to handle backups and tape rotations. Each tray employed multiple hot spares.
		    				</MarketingBlock>
		    			</Col>
		    		</Row>
	    		</div>
	    	</Grid>

    	</div>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default ITBuildOut;



// WEBPACK FOOTER //
// ./src/cba/appspec/body/ITBuildOut.js